import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../authentication/guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';
import { id } from '@swimlane/ngx-datatable/release/utils';

@Injectable()
export class EventService {
  constructor(private apiService: ApiService) { }

  create(event, appid) {
    return this.apiService.post('/event/' + appid, event).map(data => data);
  }

  getListOfEvent(id, showExpiredEvent) {
    return this.apiService.get('/eventlist/' + id + '/' + (showExpiredEvent ? 1 : 0)).map(data => data);
  }

  getEventById(id) {
    return this.apiService.get('/event/' + id).map(data => data);
  }

  delete(id, appid) {
    return this.apiService.delete('/event/' + appid + '/app/' + id).map(data => data);
  }

  approve(event, appid) {
    return this.apiService.post('/eventapproved/' + appid, event).map(data => data);
  }

  reject(event, appid) {
    return this.apiService.post('/eventrejected/' + appid, event).map(data => data);
  }

  getListOfEventRequests(appId) {
    return this.apiService.get('/eventrequestlist/' + appId).map(data => data);
  }

  getListOfEventCheckin(eventId) {
    return this.apiService.get('/eventcheckinlist/' + eventId).map(data => data);
  }
  getListOfEventParticipant(eventId) {
    return this.apiService.get('/eventparticipatelist/' + eventId).map(data => data);
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/event-management/event-management.ts